import { generateUUID } from '@wix/form-schema';
import React, { useRef } from 'react';
export const useId = typeof React.useId === 'function' ? React.useId : () => useRef(generateUUID()).current;
//# sourceMappingURL=use-id.js.map